import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';

import LabeledField from '@zr/components/Fields/LabeledField';

import FormActions from '../../../components/FormActions';
import QuestionLabel from '../../../components/QuestionLabel';

import IndexedLegend from './IndexedLegend';
import FormButtons from './FormButtons';

import { patchProfileForm } from './utilities';

const PHONE_NUMBER = 'phone_number';

export function PhoneNumber({
  index, onContinue, onError, onSkip, submitButtonText, totalScreeningQuestions,
  isInJs6650Test, setIsLoading,
}) {
  const handleContinue = async (values, formik) => {
    // `setIsLoading(true)` so that we can disable the close button while the
    // screen is processing/loading
    setIsLoading(true);
    await patchProfileForm(values, formik, onContinue, onError);
  };

  return (
    <Formik
      initialValues={{ [PHONE_NUMBER]: '' }}
      onSubmit={handleContinue}
      validationSchema={Yup.object().shape({
        [PHONE_NUMBER]: Yup.string().required('Phone Number is required'),
      })}
    >
      {({
        errors, handleChange, handleSubmit, isSubmitting, touched, values,
      }) => (
        <form className="Suggestion" onSubmit={handleSubmit}>
          <fieldset>
            {isInJs6650Test && (
              <QuestionLabel
                as="legend"
                html="Please provide the phone number a hiring manager can use to reach you."
                number={index}
                totalQuestions={totalScreeningQuestions}
              />
            )}
            {!isInJs6650Test && (
              <IndexedLegend index={index} text="Please provide the phone number a hiring manager can use to reach you." />
            )}
            <LabeledField
              input={{
                disabled: isSubmitting,
                name: PHONE_NUMBER,
                onChange: handleChange,
                value: values[PHONE_NUMBER],
              }}
              label="Phone"
              meta={{
                error: errors[PHONE_NUMBER],
                touched: touched[PHONE_NUMBER],
              }}
              placeholder="Phone"
              maxLength={30}
              type="tel"
            />
            {isInJs6650Test && (
              <FormActions
                disableContinue={isSubmitting}
                disableSkip={isSubmitting}
                onSkip={onSkip}
                submitButtonText={submitButtonText}
              />
            )}
            {!isInJs6650Test && (
              <FormButtons disabled={isSubmitting} onSkip={onSkip} submitButtonText={submitButtonText} />
            )}
          </fieldset>
        </form>
      )}
    </Formik>
  );
}

PhoneNumber.propTypes = {
  index: PropTypes.number.isRequired,
  isInJs6650Test: PropTypes.bool,
  onContinue: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onSkip: PropTypes.func,
  setIsLoading: PropTypes.func,
  submitButtonText: PropTypes.string,
  totalScreeningQuestions: PropTypes.number.isRequired,
};

PhoneNumber.defaultProps = {
  isInJs6650Test: false,
  onSkip: null,
  setIsLoading: () => {},
  submitButtonText: 'Continue',
};

export default PhoneNumber;
